module.exports = __webpack_public_path__ + "img/unknown.80d49721.svg";